import InfoIcon from '@mui/icons-material/Info';
import { Chip } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { LibraryIndicatorT } from 'modules/decision/types/indicators';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

import { isCityIndicator, isNewIndicator } from '../helpers';
import SeeOriginalButton from './SeeOriginalButton';

type Props = {
    indicator: LibraryIndicatorT;
    isExploreUser: boolean;
    isInExplore?: boolean;
};

const IndicatorHeader = ({
    indicator,
    isExploreUser,
    isInExplore = false,
}: Props): JSX.Element => {
    const { t } = useTranslation();
    const showSeeOriginalButton = isCityIndicator(indicator);
    const isNew =
        !isCityIndicator(indicator) && isNewIndicator(indicator.createdAt);

    return (
        <Flex gap={1}>
            {isNew && (
                <Chip
                    label={t('indicators.new')}
                    size="small"
                    sx={{
                        color: 'white',
                        backgroundColor: (theme) => theme.palette.warning.main,
                    }}
                />
            )}
            <Flex
                flex={1}
                minWidth={0}
                align="center"
                justify={showSeeOriginalButton ? 'space-between' : 'initial'}
            >
                <Tooltip title={indicator.title}>
                    <Typography
                        noWrap
                        variant="body1SemiBold"
                        sx={{
                            '&:first-letter': { textTransform: 'initial' },
                            flex: 1,
                            mr: 1,
                        }}
                    >
                        {indicator.title}
                    </Typography>
                </Tooltip>
                {showSeeOriginalButton
                    ? !isInExplore && (
                          <SeeOriginalButton
                              route={
                                  isExploreUser
                                      ? `/explore/${indicator.key}`
                                      : `/dashboard/${indicator.dashboardSlug}#widget-${indicator.widgetKey}`
                              }
                          />
                      )
                    : !!indicator.description && (
                          <Tooltip title={indicator.description}>
                              <InfoIcon fontSize="small" />
                          </Tooltip>
                      )}
            </Flex>
        </Flex>
    );
};

export default IndicatorHeader;
